import React, { useState } from "react";
import FmStepper from "../FmStepper";
import { FmStepIcon, FmCollapsible } from "../../";

import useStyles from "./FmMobileStepper.style";

interface FmMobileStepper {
  data: {
    icon: any;
    desktopLabel: string;
    mobileLabel: string;
  }[];
  activeItemIndex: number;
  onItemSelect: (index: number) => void;
  handleExpandClick: () => void;
  expended: any;
}

const FmMobileStepper = ({ data, activeItemIndex, onItemSelect, handleExpandClick, expended }: FmMobileStepper) => {
  const classes = useStyles();

  const renderTitle = () => {
    if (activeItemIndex === 2.5) {
      activeItemIndex = 2;
    }

    const activeItem = data[activeItemIndex];

    return (
      <div className={classes.mobileStepper_box}>
        <div className={classes.iconWithLabelBox}>
          <FmStepIcon icon={activeItem.icon} active={true} />
          <div className={classes.labelOnly}>{activeItem.desktopLabel}</div>
        </div>
        <div className={classes.numberWithDropDown}>
          {`0${activeItemIndex + 1}`}
          <span className={classes.grey_span}>{`/0${data.length}`}</span>
        </div>
      </div>
    );
  };

  if (activeItemIndex === 2.5) {
    return <></>;
  }

  return (
    <div className={classes.mobileStepper_container}>
      <FmCollapsible renderTitle={renderTitle()} stepNumber={activeItemIndex} expended={expended} handleExpandClick={handleExpandClick}>
        <FmStepper data={data} activeItemIndex={activeItemIndex} onItemSelect={onItemSelect} />
      </FmCollapsible>
    </div>
  );
};

export default FmMobileStepper;
